/* Atlas Wood Company: buyer-path fixes (Oct 2026)
   - #custom-size in a canvas product URL opens the custom size fields (used by the homepage "Price your canvas" link)
   - Phones: a sticky price + Add to cart bar on pages with the frame configurator. It mirrors the configurator,
     never replaces it: tapping it presses the real Add to cart, or scrolls to the first unanswered step. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var root = document.querySelector('.awc:not(.awc-stage)');
    if (!root) return;

    // Deep link: open custom size
    if (location.hash === '#custom-size') {
      var t = root.querySelector('[data-toggle]'), box = root.querySelector('[data-custom]');
      if (t && box && box.hidden) t.click();
      setTimeout(function () {
        var step = root.querySelector('[data-step="size"]') || root;
        step.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var w = root.querySelector('[data-dim="w"]'); if (w && window.matchMedia('(min-width: 750px)').matches) w.focus({ preventScroll: true });
      }, 350);
    }

    // Sticky bar (phones)
    var mq = window.matchMedia('(max-width: 749px)');
    var add = root.querySelector('[data-add]'), priceEl = root.querySelector('[data-price]'), specEl = root.querySelector('[data-spec]');
    var summary = root.querySelector('.awc__summary'), fromEl = document.querySelector('[data-from]');
    if (!add || !summary) return;

    var bar = document.createElement('div');
    bar.className = 'awc-bar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="awc-bar__info"><span class="awc-bar__spec"></span><span class="awc-bar__price"></span></div><button type="button" class="awc-bar__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    var bSpec = bar.querySelector('.awc-bar__spec'), bPrice = bar.querySelector('.awc-bar__price'), bBtn = bar.querySelector('.awc-bar__btn');

    function ready_() { return !add.classList.contains('is-off') && add.getAttribute('aria-disabled') !== 'true'; }
    function sync() {
      var p = (priceEl && priceEl.textContent.trim()) || '';
      var ok = ready_() && p && p !== '—';
      bPrice.textContent = ok ? p : 'From ' + ((fromEl && fromEl.textContent.trim()) || '');
      var steps = root.querySelectorAll('.awc__step'), done = root.querySelectorAll('.awc__step.is-done').length;
      bSpec.textContent = ok ? ((specEl && specEl.textContent.trim()) || 'Ready to build') : (done + ' of ' + steps.length + ' chosen');
      bBtn.textContent = ok ? 'Add to cart' : 'Choose options';
      bBtn.classList.toggle('is-pending', !ok);
      if (add.classList.contains('is-switch')) {   // previewing another wood: the bar leads to that listing too
        var m = add.textContent.match(/to (.+?) listing/);
        bBtn.textContent = m ? 'Go to ' + m[1] : 'Switch wood';
        bBtn.classList.remove('is-pending');
      }
    }
    sync();
    new MutationObserver(sync).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-disabled'] });

    bBtn.addEventListener('click', function () {
      if (ready_() || add.classList.contains('is-switch')) { add.click(); return; }
      var miss = root.querySelector('.awc__step:not(.is-done)') || summary;
      miss.scrollIntoView({ behavior: 'smooth', block: 'center' });
      miss.classList.remove('is-nudge'); void miss.offsetWidth; miss.classList.add('is-nudge');
      setTimeout(function () { miss.classList.remove('is-nudge'); }, 1600);
    });

    // Show once the top of the configurator has scrolled away, hide while the real price box is on screen
    var ticking = false;
    function check() {
      ticking = false;
      var vh = window.innerHeight, r = root.getBoundingClientRect(), s = summary.getBoundingClientRect();
      var summaryVisible = s.top < vh && s.bottom > 0;
      var on = mq.matches && r.top < 0 && !summaryVisible;
      if (on === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bBtn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('awc-bar-on', on);
    }
    function show() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', show, { passive: true });
    window.addEventListener('resize', show);
    show();
    mq.addEventListener ? mq.addEventListener('change', show) : mq.addListener(show);
  });
})();

/* Gift cards are emailed: drop the "Free shipping" line on that product */
(function(){ if (/\/products\/gift-card/.test(location.pathname)) { var s=document.createElement('style'); s.textContent='.product__tax{display:none!important}'; document.head.appendChild(s); } })();

/* Canvas product pages: the top price reads "From $191" until every step is chosen */
(function(){
  function go(){
    var root=document.querySelector('.awc:not(.awc-stage)'), from=document.querySelector('[data-from]'), add=root&&root.querySelector('[data-add]');
    if(!from||!add) return;
    function s(){ from.classList.toggle('awc-from--base', add.classList.contains('is-off')); }
    s(); new MutationObserver(s).observe(add,{attributes:true,attributeFilter:['class']});
  }
  if(document.readyState!=='loading') go(); else document.addEventListener('DOMContentLoaded',go);
})();
